import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Endpoints } from 'src/app/shared/config/endpoints';
import { GeneralService } from "../../general.service";
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class EmailClientService {
  owner: number;
  orgId: number;

  private host =  this.endpoints.fourFourSixEndpoint;
  recipient_group: any = new BehaviorSubject<string>('');

  constructor(
    private endpoints: Endpoints,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe( info => {
      if (Object.keys(info).length ) {
        this.owner = info.user.id;
        this.orgId = info.organization.id;
      }
    });
  }

  fetchClientsByWildcard(wildcard: string, baseRoute: string, query?: any) {
    return this.http.get(`${this.host}/${baseRoute}/wildcard/${wildcard}?${query}`);
  } 

}
